<div class="row rejectedSection" [ngClass]="isArabic ? 'rightAlign' : ''">
    <div class="noCaseMsg" *ngIf="cases == undefined || cases == null || cases.length <= 0">
        <p>
            <span *ngIf="!isArabic">No cases raised yet. You will see the items once you create a case.</span>
            <span *ngIf="isArabic"> .لا توجد حالات تم إنشاؤها بعد. ستظهر العناصر بمجرد إنشاء حالة</span>

        </p>
    </div>
    <ng-container *ngIf="cases && cases.length > 0">
        <label class="rejectedLabel">
            <span *ngIf="!isArabic">Previous Cases :</span>
            <span *ngIf="isArabic">: الحالات السابقة</span>
        </label>
        <div *ngFor="let eachCase of cases; let idx = index" class="col-12 mb-3 rejectedQuesDiv">
            <div class="col-12 innerDiv" (click)="openCase(eachCase)">
                <div class="row" [ngClass]="isArabic ? 'arabicAlign' : ''">
                    <label class="col-8 quesNo" [ngClass]="isArabic ? 'arabicAlign' : ''">
                        <span class="spanLabel">
                            <span *ngIf="!isArabic">Ticket Number : </span>
                            <span *ngIf="isArabic"> : رقم الطلب</span>
                        </span>
                        <span class="font-radikal-light">{{eachCase.ticketNumber}}</span>
                    </label>
                    <label class="col-4 createdOn" [ngClass]="isArabic ? 'arabicAlign' : ''">
                        <span class="spanLabel">
                            <span *ngIf="isArabic"> اريخ الإنشاء : </span>
                            <span *ngIf="!isArabic">Created On : </span>

                        </span>
                        <span class="font-radikal-light">{{eachCase.createdon}}</span>
                    </label>
                </div>
                <div class="row" [ngClass]="isArabic ? 'arabicAlign' : ''">

                    <div class="col-8" [ngClass]="isArabic ? 'arabicAlign' : ''">
                        <label class="col-12 boldTxt caseType" [ngClass]="isArabic ? 'arabicAlign' : ''">
                            <span class="spanLabel">
                                <span *ngIf="!isArabic">Case Type : </span>
                                <span *ngIf="isArabic">: نوع الطلب</span>
                            </span>
                            <span>
                                <span class="font-radikal-light">{{eachCase.caseType}}</span>
                                <span *ngIf="eachCase.caseType == 'User Access Request'"> for
                                    {{eachCase.requestUserName}}</span>
                            </span>
                        </label>
                    </div>
                    <!-- <div class="col-12" *ngIf="eachCase.caseType !== 'User Access Request'">
                        <label class="col-12 boldTxt caseType" [ngClass]="isArabic ? 'arabicAlign' : ''">
                            <span>{{eachCase.title}}</span>
                        </label>
                    </div> -->
                    <!-- <div [ngClass]="eachCase.caseType == 'User Access Request' ? 'mt-2' : ''">
                        <label class="caseDesc" [ngClass]="isArabic ? 'arabicAlign' : ''">
                            <span class="caseType boldTxt spanLabel">
                                <span *ngIf="!isArabic">Case Details : </span>
                                <span *ngIf="isArabic">: تفاصيل الحالة</span>
                            </span>
                            <span>{{eachCase.description}}</span>
                        </label>
                    </div> -->
                    <div class="col-4" [ngClass]="isArabic ? 'arabicRowAlign' : ''">
                        <div class="statusSec" [ngClass]="isArabic ? 'arabicAlign' : ''">
                            <label class="quesNo" [ngClass]="isArabic ? 'arabicAlign' : ''">
                                <span class="spanLabel">
                                    <span *ngIf="!isArabic">Status: </span>
                                    <span *ngIf="isArabic">: الحالة</span>
                                </span>
                                <span class="font-radikal-light">{{eachCase.status}}</span>
                            </label>
                            <!-- <button type="submit" class="btn btn-primary" (click)="reopenTheCase(eachCase, idx)" 
                            [ngClass]="isArabic ? 'arabicAlign' : ''" *ngIf="eachCase.status == 'Resolved'">
                                <span *ngIf="!isArabic">Reopen</span>
                                <span *ngIf="isArabic">أعد فتح</span>
                            </button> -->
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </ng-container>
</div>